// logger util
// @AUTHOR CAIHUAZHI <huazhi.chz@alibaba-inc.com>
// @CREATE 2023/08/24 12:19
import { timestamp } from './common';
export const loggerNames = ['debug', 'success', 'info', 'warn', 'error'];
const { hostname, port, search } = (typeof window !== 'undefined' ? window.location : {});
const showLog = /dev|daily|test|pre-|(\d+\.\d+\.\d+\.\d+)/.test(hostname) || +port > 1000 || /debug/.test(search);
export const loggerConfigs = Object.assign({ debug: { color: '#999', valid: showLog }, error: { color: '#f20', valid: true }, warn: { color: '#f90', valid: true }, info: { color: '#0cd', valid: showLog }, success: { color: '#3b4', valid: showLog } }, window.__loggerConfig);
/**
 * 打印控制台日志
 */
export const logger = (function () {
    const _factory = (name) => {
        const { color, valid } = loggerConfigs[name] || {};
        return (...args) => {
            if (!valid || !color)
                return;
            const prefix = typeof args[0] === 'string' ? args.shift() : '';
            // eslint-disable-next-line
            console.log(`%c%s%c【${name}】${prefix}`, 'color:#999', timestamp(), `color:${color}`, ...args);
        };
    };
    return loggerNames.reduce((prev, name) => {
        return Object.assign(Object.assign({}, prev), { [name]: _factory(name) });
    }, {});
})();
